const ErrorPage = ({error}: {error: Error}) => {

  return (
    <div className="page-container">
      <div className="centered-content">
        <div className="ollama-logo crazy">🤪</div>
        <h1 className="error-title">UI Error</h1>
        <h2 className="error-subtitle">{error.message}</h2>
        <p className="error-description">
          Whoa! Something went completely bonkers on our end. 
          Our llama is having a bit of a meltdown!
          {error.stack && (
            <pre className="error-stack"> {error.stack}</pre>
          )}
        </p>
        <button className="home-btn" onClick={() => window.location.href = '/'}>
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;